import { Component, OnInit, Input, Output, EventEmitter, OnDestroy, OnChanges, SimpleChanges } from '@angular/core';
import { ConfigService } from '../../config-builder/service/config.service';
import { Subject } from 'rxjs';

declare var $: any
@Component({
	selector: 'app-table-modal',
	templateUrl: './table-modal.component.html',
	styleUrls: ['./table-modal.component.css']
})
export class TableModalComponent implements OnInit, OnDestroy {
	@Input() id = '';
	@Input() data_view_type;
	@Input() data_view_id = null;
	@Input() row_detail = [];
	@Input() show_lg_data_download?: boolean= true;
	@Input() col_detail = [];
	@Input() button_template_select = false;
	@Input() selected_templates = [];
	@Input() selected_data_objects = {};
	@Input() drill_list = [];
	@Output() modal_event: EventEmitter<any> = new EventEmitter<any>();
	@Output() ext_btn_event: EventEmitter<any> = new EventEmitter<any>();
	@Output() table_modal_events: EventEmitter<any> = new EventEmitter<any>();
	@Input() external_buttons?: any = []
	selected_row = -1
	search_data = ''
	filtered_list = [...this.row_detail];
	display_list=[];
	loading = false;
	record_per_page = 10;
	page = {
			'totalElements': 0,
			'pageNumber': 0,
			'size': this.record_per_page,
		}
	total_pages = 0
	page_num_list = []
	start = this.page.pageNumber * this.page.size;
	end = this.start + this.page.size;

	// [
	//     {
	//         "button_label": "TASK",
	//         "button_title": "Task",
	//         "button_icon": "tasks",
	//         "button_case": "task_id",
	//         "button_type": "label",
	//         "key_for_lg_id": "task_id"
	//     },
	//     {
	//         "button_label": "Task Status",
	//         "button_type": "label",
	//         "button_title": "Task Status",
	//         "button_icon": "angry",
	//         "button_case": "task_status",
	//         "key_for_lg_id": "task workflow status"
	//     }
	// ]
	selected_temp_index = -1;
	constructor(
		private _configService: ConfigService,
	) { }

	ngOnInit() {
	}

	ngOnChanges(changes: SimpleChanges): void {
		if (changes.row_detail) {
			this.reset_scroll_position();
			this.reset_filtered_list();
		}
	}	
	
	reset_scroll_position(){
		const scrollElement = document.getElementById(this.id + 'lg_data_recs_table_data');
		if(scrollElement){
			scrollElement.scrollTop = 0;
			scrollElement.scrollLeft = 0;
		}       
	}

	sendMail() {
		this.modal_event.emit({ 'case': 'send_mail', 'value': this.selected_temp_index });
	}

	download_chart_report() {

		var header = [];
		for (var i = 0; i < this.col_detail.length; i++) {
			header.push({ "col_name": this.col_detail[i], "disp_name": this.col_detail[i] });
		}
		var payload = { "data_records": this.row_detail, "data_header": header };

		this._configService.download_chart_report(payload).subscribe(res => {
			let payload2 = { "file_type": "report", "file_name": res.filename };
			if (((localStorage.getItem('leggero_username') != null) || (localStorage.getItem('leggero_username') != undefined))) {
				const is_admin=JSON.parse(localStorage.getItem('lg_admin'))
				payload2['logdata'] = {
				"logtype": this.data_view_type,
				"logdata": {
					"user_name": localStorage.getItem('leggero_username'),
					"main_itemname": res.filename,
					"main_itemid": this.data_view_id,
					"drills": this.drill_list,
					"dashboard_name": localStorage.getItem('lg_dashboard_name'),
					"system_access_id": localStorage.getItem('system_access_id'),
					"is_admin_panel": is_admin == undefined? 0: is_admin,
				}}
			}
			this._configService.download_report(payload2).subscribe(res2 => {
				window.open(res2.download_link, "_blank");
			});
		});

	}

	ext_btn_event_handler(btn) {
		let data = {
			"button_case": btn['button_case'],
			"lg_data_rec": this.row_detail[this.selected_row],
			"lg_id": this.row_detail[this.selected_row][btn['key_for_lg_id']] ? this.row_detail[this.selected_row][btn['key_for_lg_id']] : null,
		}
		console.log(data)
		this.ext_btn_event.emit(data);
		console.log('emitted')
	}

	ngOnDestroy() {
		this.close_modal();
	}

	select_row(n) {
		this.selected_row = n
		console.log(this.row_detail[n])
	}
	
	setPage(pageInfo) {
		this.loading = true;
		this.display_list = [];
		
		setTimeout(() => {
			this.page.pageNumber = pageInfo.offset;
			this.start = this.page.pageNumber * this.page.size;
			this.end = this.start + this.page.size;
			this.display_list = this.filtered_list.slice(this.start, this.end);
			this.loading = false;
			this.selected_row = -1;
		}, 0);
	}

	onChangePage(value) {
		this.setPage({offset:parseInt(value)})
	}
	reset_pagination_values(){
		this.setPage({ offset: 0 });
		this.page.totalElements = this.filtered_list.length;
		this.total_pages = Math.ceil(this.page.totalElements / this.page.size);
		this.page_num_list = Array(this.total_pages).fill(0).map((_, i) => i);
	}

	reset_filtered_list(clearSearch: boolean = true) {	
		if (clearSearch || !this.search_data || this.search_data === ''){
			this.loading = true;
			this.display_list = [];
		}
		if (clearSearch) {
			this.search_data = '';
			this.filtered_list = [...this.row_detail];
		}
		setTimeout(() => {
			if (!this.search_data || this.search_data === '') {
				this.filtered_list = [...this.row_detail];				
			}
			this.reset_pagination_values();
			this.loading = false;
		}, 0);
	}

	filterdata() {
		this.filtered_list = [];
		this.search_data = this.search_data.trim();
		this.loading = true;
		this.display_list=[]
		setTimeout(() => {
			if (this.search_data == '') {
				this.filtered_list = [...this.row_detail];
			} else {
				let matched_rows = this.row_detail.filter(row =>
					this.col_detail.some(col =>
						row[col] && row[col].toString().toLowerCase().includes(this.search_data.toLowerCase())
					)
				);
				this.filtered_list = matched_rows;
			}
			this.reset_pagination_values()
			this.loading= false
		}, 0);
	}	
	
	search_event(event) {
		this.filterdata();
	}
	
	close_modal() {		
		this.reset_scroll_position();
		this.reset_filtered_list();

		this.display_list = [];
		this.filtered_list = [];
		this.row_detail = [];
		this.table_modal_events.emit({
			event_type: 'close_lg_data_recs_modal'
		})	
		
		$('#' + this.id).modal('hide');
		this.modal_event.emit({ 'case': 'close_modal', 'value': '' });
	}
	
}
